<template>
    <div id="Login">
        <div class="lTop">
            <div class="lNav">
                <div :class="{ active: i == 0 }" @click="getI(0)">个人登录</div>
                <div :class="{ active: i == 1 }" @click="getI(1)">企业登录</div>
                <div :class="{ active: i == 2 }" @click="getI(2)">专家登录</div>
            </div>
            <span @click="closeLogin">×</span>
        </div>
        <div class="lMain">
            <div class="lText">
                <div>
                    蚂蚁城全国煤炭行业管理创新平台注册用户均可登录本系统。
                    <br />如您尚未注册，请您点击“新用户注册”注册信息通过审核后进行登录本系统。
                </div>
                <span class="btn" @click="goRegister()">新用户注册</span>
            </div>
            <div class="lInput">
                <img src="../assets/public/0.8.png" />
                <div class="Input">
                    <input type="text" v-model="uName" placeholder="请输入手机号" />
                    <input style="margin-bottom: 10px" type="password" v-model="uPass" placeholder="请输入密码" />
                </div>
                <router-link to="changePassword">忘记密码?</router-link>
                <div class="btn" @click="CLogin()">用户登录</div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
export default {
    name: "Login",
    data() {
        return {
            i: 0,
            uName: "",
            uPass: "",
            type: "",
        };
    },
    props: {},
    inject: ["reload"],
    created() {
        // let that = this;
        // document.onkeydown = function(e) {
        //   e = window.event || e;
        //   if (
        //     that.$route.path == "/" &&
        //     (e.code == "Enter" || e.code == "enter")
        //   ) {
        //     //验证在登录界面和按得键是回车键enter
        //     that.CLogin(); //登录函数
        //   }
        // };
    },
    mounted() {
        window.addEventListener("keydown", this.keyDown);
    },
    destroyed() {
        window.removeEventListener("keydown", this.keyDown, false);
    },
    methods: {
        keyDown(e) {
            //如果是回车则执行登录方法
            if (e.keyCode == 13) {
                this.CLogin();
            }
        },
        closeLogin() {
            this.$emit("LoginOpen", true);
        },
        openLogin() {
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;
            console.log(regex.test(this.uPass))
            // 当用户密码符合要求或直接关闭右上角就单纯关闭登录弹窗，否则将true代入
            if (regex.test(this.uPass)) {
                this.$emit("LoginOpen", true);
            } else {
                this.$emit("LoginOpen", false);
            }
        },
        getI(e) {
            this.i = e;
        },
        goRegister() {
            if (this.$router.path != "/Register") {
                this.$router.replace("/Register");
            } else {
                this.closeLogin();
            }
        },
        CLogin() {
            var that = this;
            if (this.i == 0 || this.i == 2) {
                let type = 1;
                if (this.i == 2) {
                    type = 2;
                }
                console.log(that.uName, that.uPass);
                that.$axios
                    .post(
                        "login/userlogin",
                        this.$qs.stringify({
                            username: that.uName,
                            password: that.uPass,
                            types: type,
                        })
                    )
                    .then(function (res) {
                        console.log(res, "用户登录");
                        if (res.data.code == "10000") {
                            let date = new Date();
                            that.$message({ message: "登入成功", type: "success" });
                            sessionStorage.setItem("token", res.data.data.user_token);
                            sessionStorage.setItem("date", date);
                            sessionStorage.setItem("userinfo", JSON.stringify(res.data.data.user_info));
                            sessionStorage.setItem("name", res.data.data.user_info.Realname);
                            sessionStorage.setItem("name", res.data.data.user_info.Realname);
                            Vue.prototype.$uName = res.data.data.user_info.Realname;
                            if (that.i == 2) {
                                // 专家登录
                                sessionStorage.setItem("t", 2);
                            } else {
                                // 个人登录
                                if (JSON.parse(sessionStorage.getItem("userinfo")).Phone == 16666666666) {
                                    sessionStorage.setItem("t", 5);
                                } else {
                                    sessionStorage.setItem("t", 1);
                                }
                            }
                            that.openLogin();
                            that.$router.push("/");
                            that.reload();
                        } else {
                            that.$message.error(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        that.$message.error("登入失败");
                    });
            } else {
                that.$axios
                    .post("login/companylogin?username=" + that.uName + "&password=" + encodeURIComponent(that.uPass))
                    .then(function (res) {
                        console.log(res, "企业");
                        if (res.data.code == "10000") {
                            that.openLogin();
                            that.$router.push("/");
                            that.reload();
                            that.$message({ message: "登入成功", type: "success" });
                            sessionStorage.setItem("token", res.data.data.user_token);
                            sessionStorage.setItem("name", res.data.data.user_info.Name);
                            sessionStorage.setItem("userinfo", JSON.stringify(res.data.data.user_info));
                            // sessionStorage.setItem(
                            //   "userinfo",
                            //   JSON.stringify(res.data.data.user_info)
                            // );
                            // console.log(sessionStorage.getItem("userinfo"));
                            Vue.prototype.$uName = res.data.data.user_info.Name;
                            // 企业登录
                            sessionStorage.setItem("t", 2);
                            if (res.data.data.user_info.ID != 1) {
                                that.$axios
                                    .post("statistic/thisCompanyStatistic?token=" + res.data.data.user_token)
                                    .then((res) => {
                                        if (res.data.code == 10001) {
                                            if (res.data.data.jj == "no" && res.data.data.zb == "no") {
                                                that.$alert(
                                                    "您的单位统计指标还未上报以及企业简介未填写，请尽快完善",
                                                    "提示",
                                                    {
                                                        confirmButtonText: "确定",
                                                        callback: () => {
                                                            that.$router.push("/Specification");
                                                        },
                                                    }
                                                );
                                            } else {
                                                if (res.data.data.zb == "no") {
                                                    that.$alert("您的单位统计指标还未上报,请尽快完善", "提示", {
                                                        confirmButtonText: "确定",
                                                        callback: () => {
                                                            that.$router.push("/Specification");
                                                        },
                                                    });
                                                } else if (res.data.data.jj == "no") {
                                                    that.$alert("您的企业简介还未填写,请尽快填写", "提示", {
                                                        confirmButtonText: "确定",
                                                        callback: () => {
                                                            that.$router.push("/Information");
                                                        },
                                                    });
                                                }
                                            }
                                        }
                                        // if (res.data.code == 10001) {
                                        //   that.$alert(
                                        //     "您的单位统计指标还未上报,请尽快完善",
                                        //     "提示",
                                        //     {
                                        //       confirmButtonText: "确定",
                                        //       callback: () => {
                                        //         that.$router.push("/Specification");
                                        //       }
                                        //     }
                                        //   );
                                        // }
                                    });
                            }
                        } else {
                            that.$message.error(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        that.$message.error("登入失败");
                    });
            }
        },
    },
};
</script>
<style lang="less" scoped>
#Login {
    width: 500px;
    height: 370px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100000;
    border: 15px solid rgba(0, 0, 0, 0.2);

    .lTop {
        width: 100%;
        display: flex;
        justify-content: space-between;
        background: #f3f3f3;
        padding: 10px;

        span {
            color: #c5c3c4;
            font-size: 20px;
            line-height: 1;
            cursor: pointer;
        }

        .lNav {
            display: flex;
            font-size: 15px;

            div {
                padding: 5px 10px;
                width: 100px;
                background: #9fa0a0;
                border-radius: 5px;
                color: #fff;
                text-align: center;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    background: #3694e6;
                }
            }
        }
    }

    .lMain {
        background: #fff;
        padding: 15px;
        display: flex;
        line-height: 2;
        height: calc(100% - 50px);

        .btn {
            width: 100px;
            padding: 5px 10px;
            color: #fff;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            font-size: 15px;
            cursor: pointer;
        }

        .lText {
            height: 100%;
            flex-shrink: 0;
            width: 150px;
            font-size: 13px;
            color: #aaaaaa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-right: 15px;
            border-right: 1px solid #c7c7c7;

            .btn {
                background: #44b983;
                width: 100%;
            }
        }

        .lInput {
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            position: relative;

            a {
                font-size: 0.16rem;
                position: absolute;
                bottom: 55px;
                text-decoration: underline;
                color: royalblue;
                right: 20px;
            }

            img {
                width: 250px;
                margin-bottom: 35px;
            }

            .Input {
                width: 100%;
                display: flex;
                align-items: center;
                flex-direction: column;

                input {
                    width: 250px;
                    height: 35px;
                    margin: 0 auto;
                    margin-bottom: 20px;

                    padding-left: 15px;
                }
            }

            .btn {
                background: #3694e6;
                width: 250px;
            }
        }
    }
}
</style>
